module.exports = __webpack_public_path__ + "static/assets/91eb1823e48703c01d4438e761bbc5be.gif";